// @flow
import React, { useEffect, useState } from 'react';
import { flatten } from 'lodash';
import Slider from 'react-slick';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dotdotdot from 'react-dotdotdot';
import { HTMLView } from 'components/atoms/htmlView';
//eslint-disable-next-line
import styles from "./styles.scss";
import bedRoomIcon from 'assets/images/bedWhite.png';
import bathRoomIcon from 'assets/images/bathroomWhite.png';
import RupeeIcon from 'assets/images/rupee-icon-black.png';

type Props = {
  data: Array,
  fetchTitle: Component,
  onClick: () => void,
  isDisplayLocationIcon?: boolean,
  displayFullArea?: boolean,
  displayDistance?: boolean,
  displayLocationBox?: boolean,
  toggleTag?: boolean,
  neighbourHood?: boolean,
  objectFit?: string,
  vertical?: string,
};

export const ListMobileCarousel = (props: Props) => {
  const {
    data,
    fetchTitle,
    onClick,
    isDisplayLocationIcon,
    displayFullArea,
    displayDistance,
    displayLocationBox,
    toggleTag,
    type,
    vertical,
  } = props;
  const isLocationIcon =
    isDisplayLocationIcon !== undefined ? isDisplayLocationIcon : true;
  const [count, setCount] = useState({
    ImageHeight: 0,
  });

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setCount({
      ...count,
      ImageHeight: window.innerHeight,
    });
  };

  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 1.06,
    slidesToScroll: 1,
    arrows: false,
    verticalSwiping: false,
    swipeToSlide: true,
    speed: 1000,
    touchThreshold: 3000,
    draggable: true,
    centerMode: false,
  };

  const renderSlider = () => {
    let margin = data.length < 2 ? '0vw' : '3vw';
    let transform_heading = data.length < 2 ? '1vw' : '4vw';
    return data.map((list, idx) => {
      return (
        <div key={idx} className={'inner'} onClick={() => onClick(list)}>
          <Row>
            <Col xs={{ span: 11 }}>
              <img
                style={{
                  height: count.ImageHeight * 0.68,
                  marginLeft: margin,
                  // objectFit: objectFit ? objectFit : 'cover',
                }}
                src={list.listMobileImageUrl}
                alt={'list-image'}
              />
              <div className={'inner-content'}>
                {isLocationIcon && list.city ? (
                  <span>
                    <i className={'fa fa-map-marker fa-2x'} />
                    {list.city}
                  </span>
                ) : (
                  ''
                )}
                {
                  type==='career' || type==='restaurant' ||
                  type === 'projectDetails' ? ( <HTMLView
                  html={list.name}
                  tagName={'h1'}
                /> ):''
                }
                {type === 'rentals' ? (
                  <h1 style={{ marginLeft: transform_heading }}>
                    <img
                      className={'rupee-icon'}
                      src={RupeeIcon}
                      alt={'Rupees'}
                    />
                    {list.price}
                    <br />
                    {list.postFix}
                  </h1>
                ) : (
                  <HTMLView
                      html={list.project_name}
                      tagName={'h1'}
                    />
                )}
                {type === 'homes' || type === 'workcations' || type==='projectDetails' ||
                type === 'project' || type === 'Landcraft' ? (
                  isLocationIcon && list.short_description ? (
                    <HTMLView
                      html={list.project_list_description}
                      tagName={'p'}
                    />
                  ) : (
                    ''
                  )
                ) : isLocationIcon && list.information ? (
                  <HTMLView html={list.information} tagName={'p'} />
                ) : (
                  ''
                )}
                {!isLocationIcon && list.isTodayClose && list.currentStatus ? (
                  <Dotdotdot clamp={2} tagName={'p'}>
                    CLOSED TODAY
                  </Dotdotdot>
                ) : (
                  ''
                )}
                {!isLocationIcon && !list.isTodayClose && list.currentStatus ? (
                  <Dotdotdot clamp={2} tagName={'p'}>
                    {list.currentStatus}
                  </Dotdotdot>
                ) : (
                  ''
                )}
                {!isLocationIcon && list.location ? (
                  <Dotdotdot clamp={2} tagName={toggleTag ? 'div' : 'p'}>
                    {list.location}
                  </Dotdotdot>
                ) : (
                  ''
                )}
                {!isLocationIcon && !displayLocationBox && list.city ? (
                  <Dotdotdot clamp={2} tagName={'div'}>
                    {displayFullArea
                      ? `${list.city},${' '}${list.country}`
                      : list.city}
                  </Dotdotdot>
                ) : (
                  ''
                )}
                {!displayLocationBox && displayDistance && list.distance ? (
                  <span>{list.distance}</span>
                ) : (
                  ''
                )}
                {type === 'neighborhood' && list.distance ? (
                  <span>
                    {list.distance} <br />
                    {'FROM THIS PROPERTY'}
                  </span>
                ) : (
                  ''
                )}
                {vertical === 'architects' && (
                  <div className={'project-extra-info'}>
                    <span>{list.propertyType}</span>
                    <span>{list.projectCompletionText}</span>
                    <span>{list.copyrightText}</span>
                  </div>
                )}
                {type === 'rentals' && (
                  <div className={'image-container'}>
                    <div className={'bed-container'}>
                      <img
                        className={'bed-img'}
                        src={bedRoomIcon}
                        alt={'bed'}
                      />
                      <span className={'bed-count'}>{list.bed}&nbsp;BED</span>
                    </div>
                    <div className={'bath-container'}>
                      <img
                        className={'bath-img'}
                        src={bathRoomIcon}
                        alt={'bath'}
                      />
                      <span className={'bath-count'}>
                        {list.bath}&nbsp;BATH
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      );
    });
  };

  return (
    <div className={'mobile-project-list-view'}>
      <div className="title-heading">{fetchTitle}</div>
      <div className={'project-mobile'}>
        <Slider {...settings}>{renderSlider()}</Slider>
      </div>
    </div>
  );
};
